import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

interface BasicCardProps {
  children: React.ReactNode;
}

 function BasicCard({ children }: BasicCardProps) {
  return (
    <Card sx={{height: 350, maxWidth: 600, minWidth: 350, padding: 5, margin: 20 }}>
      <CardContent sx={{display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      { children }
      </CardContent>
    </Card>
  );
}

export default BasicCard